import { UseFormReturn } from "react-hook-form";
import { codeToFlag } from "@/features/regions/utils/code-to-flag";
import { PaymentPageWizardData } from "./wizard-form";

function Row({ label, value }: { label: string; value: React.ReactNode }) {
  return (
    <div className="flex justify-between gap-4 py-2 border-b border-gray-100 last:border-0">
      <span className="text-sm text-gray-500">{label}</span>
      <span className="text-sm text-gray-900 text-right break-all">
        {value || "—"}
      </span>
    </div>
  );
}

export default function StepReview({
  form,
}: {
  form: UseFormReturn<PaymentPageWizardData>;
}) {
  const v = form.getValues();

  return (
    <div className="rounded-lg border border-gray-200 divide-y divide-gray-100">
      <div className="px-4 py-3 bg-gray-50">
        <p className="text-base font-semibold text-gray-900">{v.page_title}</p>
        <p className="text-xs text-gray-500">
          {codeToFlag(v.region)} {v.region?.toUpperCase()} · {v.status} ·{" "}
          {v.bundle_standard_id
            ? `linked → ${v.bundle_standard_id}`
            : "no bundle (manual)"}
        </p>
      </div>
      <div className="px-4 py-2">
        <Row label="Slug" value={v.slug} />
        <Row label="Page ID" value={v.page_id} />
        <Row
          label="Fallback amount"
          value={
            v.fallback_amount != null
              ? `${v.currency} ${v.fallback_amount.toLocaleString()}`
              : "—"
          }
        />
        <Row label="Redirect link" value={v.redirect_link} />
        <Row label="Login redirect" value={v.login_redirect_url} />
        <Row label="Require auth" value={v.is_auth_enabled ? "Yes" : "No"} />
      </div>
    </div>
  );
}
